const types = {
  mutations: {
    SET_CATEGORIES: 'SET_CATEGORIES'
  },
  actions: {
    FETCH_CATEGORIES: 'FETCH_CATEGORIES'
  },
  getters: {
    GET_CATEGORY: 'GET_CATEGORY'
  }
};

export default types;
